module.exports=function(scope){ return `<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "code": 400,
        "ok": false,
        "message": "No entry found in the database for this enrollmentIdentifier."
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/failure/enrollment-get-facemap.json.tpl